import React, { useState, useEffect } from 'react';
import './static/css/layout.css';
import './static/css/homepage.css';
import '../styles/LegalComponents.css';
import Navbar from './homepage/components/Navbar';

const Footer = ({ setActivePage }) => {
    return (
        <footer>
            <div className="container_width">
                <div className="footer_bottom">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div>
                            <p className="pTag" style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px' }}>Eclipseer</p>
                            <p className="pTag" style={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.7)' }}>Customer feedback, simplified.</p>
                        </div>
                        <p className="pTag" style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.7)' }}>&copy; {new Date().getFullYear()} Eclipseer. • All rights reserved.</p>
                    </div>
                    <div className="footer_bottom_links" style={{display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center'}}>
                        <a href="#privacy" onClick={(e) => {e.preventDefault(); setActivePage('privacy')}}>Privacy Policy</a>
                        <span>•</span>
                        <a href="#terms" onClick={(e) => {e.preventDefault(); setActivePage('terms')}}>Terms of Use</a>
                        <span>•</span>
                        <a href="#cookies" onClick={(e) => {e.preventDefault(); setActivePage('cookies')}}>Cookie Policy</a>
                        <span>•</span>
                        <a href="#cookies" onClick={(e) => {e.preventDefault(); setActivePage('cookies')}}>Manage Cookies</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

const LegalPageLayout = ({ title, children, setActivePage, currentPage, setCurrentPage }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar currentPage={currentPage} setPage={setCurrentPage} />
            <main className="container_width" style={{ paddingTop: '120px', paddingBottom: '100px', color: 'white' }}>
                <div className="section_header">
                    <h1 className="section_title primaryfont" style={{ textAlign: 'left', width: '100%' }}>{title}</h1>
                    <hr style={{ margin: '20px 0' }} />
                </div>
                <div className="legal-content" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                    {children}
                </div>
            </main>
            <Footer setActivePage={setActivePage} />
        </>
    );
};


// --- Individual Legal Page Components ---

const TermsAndConditions = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="Eclipseer Terms of Use" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <article className="legal-document">
            <p className="legal-meta"><em>Version: February 2026 | Last Updated: February 22, 2026</em></p>
            <p className="legal-paragraph">
                Welcome to Eclipseer, operated by Eclipse Labs Limited (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;). These Terms of Use
                (&quot;Terms&quot;) govern your access to and use of our website at <a href="https://www.eclipseer.com">https://www.eclipseer.com</a>
                {' '} (the &quot;Site&quot;), including any demos, contact forms, Calendly demo bookings, content, or other features.
                By accessing or using the Site, you agree to these Terms. If you do not agree, please stop using the Site.
            </p>

            <ol className="legal-numbered-sections">
                <li>
                    <p className="legal-section-paragraph"><strong>Eligibility and Account</strong> You must be at least 18 years old or have legal capacity to use the Site. If using on behalf of an organization, you represent you are authorized to bind it. No account is required for general browsing, but demos or bookings may require basic info.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Permitted Use</strong> We grant you a limited, non-exclusive, revocable licence to access the Site for personal or business information purposes. You may not: (a) modify, copy, or distribute content without permission; (b) use automated tools (e.g., bots, scrapers); (c) interfere with Site functionality; (d) use for illegal or harmful activities.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Demo and AI Features</strong> The Site may include a demo AI survey builder using OpenAI models. This is for illustrative purposes only and provided &quot;as is&quot;. AI outputs may be inaccurate, incomplete, biased, hallucinatory, or unsuitable. You are responsible for any use of demo outputs. We disclaim all liability for demo results, errors, or any consequences arising from them. Do not rely on demos for production or sensitive purposes.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>User-Submitted Content</strong> Any information you submit (e.g., via contact forms or Calendly) grants us a non-exclusive licence to use it for responding, improving the Site, or providing services. You warrant your content is accurate, lawful, and does not infringe third-party rights.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Intellectual Property</strong> All Site content, trademarks, and technology are owned by us or our licensors. You may not use them except as permitted. Feedback you provide becomes our property.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Third-Party Links and Services</strong> The Site may link to third parties (e.g., Calendly for bookings, Stripe or GoCardless for payment processing). We are not responsible for their content, privacy practices, or availability. Use at your own risk.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Disclaimers</strong> The Site and its content are provided &quot;as is&quot; without warranties of any kind, express or implied, including accuracy, completeness, availability, or non-infringement. We do not guarantee the Site will be error-free, secure, or uninterrupted. AI features are experimental and not guaranteed perfect.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Limitation of Liability</strong> To the fullest extent permitted by law, we shall not be liable for any indirect, consequential, special, or punitive damages, including loss of data, profits, or goodwill. Our total liability for any claim shall not exceed £100. Nothing excludes liability for death or personal injury caused by negligence, fraud, or other non-excludable rights.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Indemnity</strong> You agree to indemnify us against claims arising from your use of the Site, breach of these Terms, or violation of laws.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Changes to Terms and Site</strong> We may update these Terms at any time; changes are effective upon posting. Continued use constitutes acceptance. We may modify or discontinue the Site without notice.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Termination</strong> We may suspend or terminate your access for any reason, including breach.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Governing Law</strong> These Terms are governed by the laws of England and Wales, with exclusive jurisdiction in the English courts.</p>
                </li>
            </ol>

            <p className="legal-paragraph">For paying business customers subscribing to Eclipseer: These Terms are supplemented by your signed Order Form, Terms &amp; Conditions (Schedule 1), and Data Processing Agreement (Schedule 2).</p>
            <p className="legal-paragraph">Contact us at <a href="mailto:info@eclipseer.com">info@eclipseer.com</a> for questions.</p>
        </article>
    </LegalPageLayout>
);

const PrivacyPolicy = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="Eclipseer Privacy Policy" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <article className="legal-document">
            <p className="legal-meta"><em>Version: February 2026 | Last Updated: February 22, 2026</em></p>
            <p className="legal-paragraph">
                Eclipse Labs Limited (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;) is committed to protecting your privacy. This Privacy Policy
                explains how we collect, use, disclose, and protect information under the UK General Data Protection Regulation
                (UK GDPR), Data Protection Act 2018, and other applicable laws. We act as data controller for Site data and
                processor for client survey data. Our contact details: info@eclipseer.com; 71-75 Shelton Street, Covent Garden,
                London, WC2H 9JQ. We are registered with the UK Information Commissioner&apos;s Office (ICO) under registration number
                ZC100828.
            </p>

            <ol className="legal-numbered-sections">
                <li>
                    <p className="legal-section-paragraph"><strong>Information We Collect</strong></p>
                    <ul className="legal-bullet-list">
                        <li>
                            <p className="legal-section-paragraph"><strong>From Website Visitors and Demo Users:</strong> We collect certain information automatically when you visit the Site, including IP address, browser type, device information, pages viewed, and referral sources (for example via Google Analytics). We also collect information you voluntarily provide, such as your name, email address, and message when submitting contact forms or booking demos via Calendly. Demo interactions (including AI prompts and outputs) may be temporarily processed and stored to enable functionality.</p>
                        </li>
                        <li>
                            <p className="legal-section-paragraph"><strong>From Survey Respondents:</strong> When you access a survey via a shared link or QR code (no login or account required), we process personal data on behalf of the business client who created the survey. This may include responses you provide (e.g., text responses or selections), as well as certain technical information automatically collected (such as IP address, device type, and timestamp). The categories of personal data collected depend entirely on the client&apos;s survey design. We do not control or determine what questions are asked. For survey respondent data, we act strictly as a data processor on behalf of the relevant business client. We do not determine the purposes or means of processing such data. The client is solely responsible for establishing a lawful basis for processing and ensuring compliance with applicable data protection laws.</p>
                        </li>
                    </ul>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>How We Use Your Information</strong></p>
                    <ul className="legal-bullet-list">
                        <li><p className="legal-section-paragraph">To operate and improve the Site (e.g., analytics, troubleshooting); respond to inquiries or bookings; provide demos.</p></li>
                        <li><p className="legal-section-paragraph">For survey respondents: Solely to collect, store, and deliver responses to the client (controller); generate reports/exports as instructed by the client. We do not use respondent data for our own marketing or other purposes.</p></li>
                        <li><p className="legal-section-paragraph">Legal bases: Consent (e.g., cookies, demos); legitimate interests (e.g., site security, analytics); contract (e.g., inquiries). For respondents: The client&apos;s lawful basis (e.g., consent or legitimate interests) - we process as instructed.</p></li>
                    </ul>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Sharing Your Information</strong></p>
                    <ul className="legal-bullet-list">
                        <li><p className="legal-section-paragraph">We may share personal data with trusted service providers and sub-processors who process data on our behalf and under appropriate contractual safeguards. These include providers of cloud hosting (e.g., AWS), analytics services (e.g., Google Analytics), AI processing services (e.g., OpenAI), and payment processing services (e.g., Stripe and GoCardless).</p></li>
                        <li><p className="legal-section-paragraph">A current list of sub-processors is available in our Data Processing Agreement (Schedule 2 to the Order Form) or upon request.</p></li>
                        <li><p className="legal-section-paragraph">We do not sell personal data and do not share personal data for third-party marketing purposes.</p></li>
                        <li><p className="legal-section-paragraph">We may disclose personal data where required by law, regulation, court order, or to establish, exercise, or defend legal claims, or in connection with a merger, acquisition, or corporate restructuring.</p></li>
                        <li><p className="legal-section-paragraph">For survey respondents, responses are shared only with the business client who created the survey. We do not use respondent data for our own marketing or independent purposes.</p></li>
                    </ul>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>International Transfers</strong> Data may be transferred outside the UK (e.g., OpenAI in US). We use safeguards like UK IDTA or EU SCCs with UK Addendum to ensure equivalent protection.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Security</strong> We use reasonable measures (e.g., encryption in transit/rest, firewalls, access controls) to protect data. However, no system is 100% secure. Breaches are notified per UK GDPR (to you and ICO if high risk).</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Retention</strong></p>
                    <ul className="legal-bullet-list">
                        <li><p className="legal-section-paragraph">Visitor/demo data: Up to 2 years or until no longer needed (e.g., inquiries deleted after resolution).</p></li>
                        <li><p className="legal-section-paragraph">Respondent data: Retained until the client deletes it or their subscription ends (then deleted per DPA, max 90 days backups).</p></li>
                    </ul>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Your Rights</strong> Under UK GDPR, you may request access, rectification, erasure, restriction, portability, or object to processing. For respondent data, contact the client first (as controller); we can assist via <a href="mailto:info@eclipseer.com">info@eclipseer.com</a>. Complain to the ICO (<a href="https://ico.org.uk/" target="_blank" rel="noopener noreferrer">ico.org.uk</a>).</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Cookies and Tracking</strong> See our <a href="#cookies" onClick={(e) => { e.preventDefault(); setActivePage('cookies'); }}>Cookie Policy</a>. We use a consent banner for non-essential cookies.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Children</strong> The Site is not for under-16s; we do not knowingly collect their data.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Changes to Policy</strong> We may update; changes posted here with email notification if material. Continued use = acceptance.</p>
                </li>
            </ol>

            <p className="legal-paragraph">For business clients subscribing to Eclipseer: We process survey data under the Data Processing Agreement (Schedule 2) incorporated into your signed Order Form.</p>
        </article>
    </LegalPageLayout>
);


const CommunityGuidelines = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="Community Guidelines / Code of Conduct" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <p className="pTag"><strong>Last Updated: September 1, 2025</strong></p>
        <p className="pTag">Eclipseer is built on respect and fairness. These Community Guidelines (“Guidelines”) apply to all participants across surveys, quests, comments, bug/feature submissions, and linked communities (e.g., Discord). By using Eclipseer, you agree to follow these Guidelines.</p>

        <h2>1. Respect Others</h2>
        <p className="pTag">No harassment, hate speech, discrimination, threats, or personal attacks. No offensive, pornographic, violent, or otherwise unlawful content.</p>

        <h2>2. Honesty & Fair Use</h2>
        <p className="pTag">Do not create multiple accounts or use bots. Do not submit false survey responses, fake bug reports, or manipulate raffles. Do not impersonate other people, brands, or organisations.</p>

        <h2>3. Intellectual Property</h2>
        <p className="pTag">Only share content you own or have rights to share. Submissions (bugs, features, comments) grant Eclipseer a royalty-free license to use, adapt, or publish them.</p>

        <h2>4. Safety & Security</h2>
        <p className="pTag">Do not attempt to hack, exploit, or disrupt the Platform. Do not share your own or others’ personal information in public areas.</p>

        <h2>5. Enforcement</h2>
        <p className="pTag">Violations may result in warnings, suspension, or permanent account bans. Severe breaches may be reported to legal authorities.</p>

        <h2>6. Reporting Misconduct</h2>
        <p className="pTag">If you see inappropriate behaviour, please report it to info@eclipseer.com.</p>
    </LegalPageLayout>
);

const CookiePolicy = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="Eclipseer Cookie Policy" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <article className="legal-document">
            <p className="legal-meta"><em>Version: February 2026 | Last Updated: February 22, 2026</em></p>
            <p className="legal-paragraph">
                This Cookie Policy explains how Eclipse Labs Limited uses cookies and similar technologies on{' '}
                <a href="https://www.eclipseer.com">https://www.eclipseer.com</a> (the &quot;Site&quot;) to enhance functionality and analyze usage,
                in compliance with the Privacy and Electronic Communications Regulations (PECR) and UK GDPR.
            </p>

            <ol className="legal-numbered-sections">
                <li>
                    <p className="legal-section-paragraph"><strong>What Are Cookies?</strong> Cookies are small text files stored on your device when you visit the Site. They help remember preferences, analyze trends, and improve experience. Similar tech includes pixels/web beacons.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Types of Cookies We Use</strong> We categorize as follows:</p>
                    <ul className="legal-bullet-list">
                        <li>
                            <p className="legal-section-paragraph"><strong>Essential Cookies:</strong> Necessary for Site operation (e.g., session management, security). No consent required; always active. Examples: PHPSESSID (purpose: maintain user session; duration: session; provider: us).</p>
                        </li>
                        <li>
                            <p className="legal-section-paragraph"><strong>Analytics Cookies:</strong> Help us understand how visitors use the Site (for example, visitor numbers, traffic sources, and page interactions). Consent is required before these cookies are set.</p>
                        </li>
                    </ul>
                    <p className="legal-section-paragraph legal-subsection-label">Examples include:</p>
                    <div className="legal-examples-block">
                        <p className="legal-example-line">_ga (purpose: distinguish users; duration: 2 years; provider: Google Analytics)</p>
                        <p className="legal-example-line">_gid (purpose: distinguish users; duration: 24 hours; provider: Google Analytics)</p>
                        <p className="legal-example-line">_gat (purpose: throttle request rate; duration: 1 minute; provider: Google Analytics)</p>
                    </div>
                    <p className="legal-section-paragraph">Analytics data may include device information, browser type, IP address, and usage information. Data is processed by Google in accordance with its privacy policy and may be transferred outside the United Kingdom. Where required, appropriate safeguards such as the UK Extension to the EU-US Data Privacy Framework or Standard Contractual Clauses are relied upon.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>How We Use Cookies</strong></p>
                    <ul className="legal-bullet-list">
                        <li><p className="legal-section-paragraph"><strong>Essential:</strong> Enable core features like navigation and forms.</p></li>
                        <li><p className="legal-section-paragraph"><strong>Analytics:</strong> Aggregate stats to improve Site (e.g., fix bugs, optimize content).</p></li>
                    </ul>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Consent and Management</strong> On first visit, a banner asks for consent to non-essential cookies. You can accept, reject, or customize. Manage anytime via the footer &quot;Cookie Settings&quot; link or browser settings (e.g., block all cookies). Rejecting may limit Site functionality. Withdraw consent by clearing cookies or emailing <a href="mailto:info@eclipseer.com">info@eclipseer.com</a>.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Third-Party Cookies</strong> Google Analytics - see <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google&apos;s privacy policy</a>. We do not control their practices.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Do Not Track</strong> We do not respond to browser DNT signals, as no standard exists.</p>
                </li>
                <li>
                    <p className="legal-section-paragraph"><strong>Changes</strong> We may update this Policy; check here for changes.</p>
                </li>
            </ol>

            <p className="legal-paragraph">For questions, contact <a href="mailto:info@eclipseer.com">info@eclipseer.com</a>. See our <a href="#privacy" onClick={(e) => { e.preventDefault(); setActivePage('privacy'); }}>Privacy Policy</a> for more on data practices.</p>
        </article>
    </LegalPageLayout>
);

const DataProcessingAgreement = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="Data Processing Agreement (DPA)" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <p className="pTag"><strong>Last Updated: September 1, 2025</strong></p>
        <p className="pTag">This Data Processing Agreement (“DPA”) forms part of the Terms & Conditions and governs the processing of personal data when Business Admins (“Controller”) use Eclipseer (“Processor”) to collect and analyse participant data.</p>

        <h2>1. Roles</h2>
        <p className="pTag">Business Admins act as Data Controllers. Eclipseer (Eclipse Labs Limited, UK) acts as Data Processor. Controllers determine the purpose and lawful basis of processing.</p>

        <h2>2. Subject Matter & Duration</h2>
        <p className="pTag">We process participant data for surveys, quests, and analytics. Processing continues while the Controller has an active account.</p>

        <h2>3. Nature & Purpose</h2>
        <p className="pTag">Collection of survey responses, data filtering, export of raw or aggregated data, and AI-powered analytics.</p>

        <h2>4. Categories of Data</h2>
        <p className="pTag">Participant profile info, survey responses, engagement logs, and submissions. Controllers are solely responsible for lawfully collecting any sensitive data.</p>

        <h2>5. Security</h2>
        <p className="pTag">Processor shall host data on AWS UK/EU servers, encrypt data, maintain access controls, and ensure staff confidentiality.</p>

        <h2>6. Subprocessors</h2>
        <p className="pTag">We may engage subprocessors (e.g., AWS, analytics providers). A list is available upon request.</p>

        <h2>7. International Transfers</h2>
        <p className="pTag">If data is transferred outside the UK/EU, we implement safeguards like Standard Contractual Clauses.</p>

        <h2>8. Data Retention</h2>
        <p className="pTag">We will retain personal data for a maximum of three years from the date of collection, after which it will be deleted or irreversibly anonymised.</p>

        <h2>9. Governing Law</h2>
        <p className="pTag">This DPA is governed by the laws of England and Wales.</p>
    </LegalPageLayout>
);

const EULA = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="End User License Agreement (EULA)" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <p className="pTag"><strong>Last Updated: September 1, 2025</strong></p>
        <p className="pTag">This End User License Agreement (“EULA”) is a legal agreement between you (“User”) and Eclipse Labs Limited. It governs your right to use the Eclipseer software platform.</p>

        <h2>1. License Grant</h2>
        <p className="pTag">Subject to your compliance with this EULA and our Terms & Conditions, Eclipseer grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Software for your internal business or personal research purposes.</p>

        <h2>2. Restrictions</h2>
        <p className="pTag">You may not copy, modify, distribute, reverse-engineer, decompile, sell, rent, or otherwise exploit the Software. You may not use it to build a competing product.</p>

        <h2>3. Ownership</h2>
        <p className="pTag">The Software is licensed, not sold. Eclipseer and its licensors retain all rights to the Software and its intellectual property.</p>

        <h2>4. Termination</h2>
        <p className="pTag">This license automatically terminates if you breach this EULA or the Terms & Conditions, or fail to maintain an active subscription.</p>

        <h2>5. Disclaimer & Liability</h2>
        <p className="pTag">The Software is provided “as is.” Our liability is limited as set out in the Terms & Conditions.</p>

        <h2>6. Governing Law</h2>
        <p className="pTag">This EULA is governed by the laws of England and Wales.</p>
    </LegalPageLayout>
);

const RewardAndRaffleTerms = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="Reward & Raffle Terms" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <p className="pTag"><strong>Last Updated: September 1, 2025</strong></p>
        <p className="pTag">These terms govern XP, rewards, and raffles on Eclipseer.</p>

        <h2>1. Eligibility</h2>
        <p className="pTag">Available globally, except where prohibited by sanctions or local law (e.g., North Korea, Iran, Syria, Cuba, Crimea region). Users must be 16+.</p>

        <h2>2. XP & Rewards</h2>
        <p className="pTag">XP has no monetary value and cannot be converted to cash. It is redeemable only within Eclipseer for raffles, vouchers, or instant rewards.</p>

        <h2>3. Raffles</h2>
        <p className="pTag">Entry requires XP; no purchase necessary. Each entry is a chance to win, not a guarantee. Winners are selected randomly.</p>

        <h2>4. Prizes</h2>
        <p className="pTag">Eclipseer covers shipping & handling. Winners are responsible for local import taxes/duties. Prizes cannot be exchanged for cash or transferred.</p>

        <h2>5. Fraud & Abuse</h2>
        <p className="pTag">Multiple/fake accounts, bots, or fraud will result in disqualification. We may cancel or modify raffles at any time.</p>

        <h2>6. Liability</h2>
        <p className="pTag">We are not responsible for lost shipments or third-party delays. Our liability is capped at the prize value.</p>

        <h2>7. Governing Law</h2>
        <p className="pTag">Governed by the laws of England and Wales.</p>
    </LegalPageLayout>
);

const ServiceLevelAgreement = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="Service Level Agreement (SLA)" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <p className="pTag"><strong>Last Updated: September 1, 2025</strong></p>
        <p className="pTag">This Service Level Agreement (“SLA”) describes the service levels for the Eclipseer platform.</p>

        <h2>1. Service Availability</h2>
        <p className="pTag">Eclipseer will use commercially reasonable efforts to make the Platform available with a monthly uptime of 99%. This excludes planned maintenance, emergency maintenance, and downtime caused by third-party services or events beyond our control.</p>

        <h2>2. Support</h2>
        <p className="pTag">Support is available via email at info@eclipseer.com. We will use commercially reasonable efforts to respond in a timely manner, but no specific response times are guaranteed. Urgent issues will be prioritised.</p>

        <h2>3. AI Services</h2>
        <p className="pTag">AI-powered features depend on third-party providers. Their availability is not guaranteed, and downtime from these providers is excluded from our uptime calculation.</p>

        <h2>4. Remedies</h2>
        <p className="pTag">If monthly uptime falls below 99%, Eclipseer may, at its discretion, provide service credits or participant panel discounts. This is the sole remedy for service issues.</p>

        <h2>5. Governing Law</h2>
        <p className="pTag">This SLA is governed by the laws of England and Wales.</p>
    </LegalPageLayout>
);

const AiUsePolicy = ({ setActivePage, currentPage, setCurrentPage }) => (
    <LegalPageLayout title="AI Use Policy / Disclaimer" setActivePage={setActivePage} currentPage={currentPage} setCurrentPage={setCurrentPage}>
        <p className="pTag"><strong>Last Updated: September 1, 2025</strong></p>
        <p className="pTag">This AI Use Policy governs the use of Eclipseer’s artificial intelligence (“AI”) features by Business Admins. By using our AI tools, you agree to this Policy.</p>

        <h2>1. Advisory Nature of AI</h2>
        <p className="pTag">AI outputs are generated automatically and are for informational purposes only. They may be inaccurate, incomplete, biased, or outdated and do not constitute legal, medical, financial, or professional advice.</p>

        <h2>2. Business Admin Responsibility</h2>
        <p className="pTag">Business Admins are fully responsible for how they use AI outputs. All AI outputs must be reviewed and approved by a human before being used, published, or relied upon. Eclipseer is not liable for any losses resulting from reliance on AI outputs.</p>

        <h2>3. Data Inputs & Sensitive Information</h2>
        <p className="pTag">Business Admins may input personal or sensitive data into AI features only if they have a lawful basis (e.g., consent under GDPR). AI prompts and outputs may be logged for up to twelve months for audit and support purposes.</p>

        <h2>4. Liability</h2>
        <p className="pTag">To the fullest extent permitted by law, Eclipseer’s liability for AI features is limited as set out in the Terms & Conditions. We are not liable for inaccurate outputs or business decisions based on them.</p>
    </LegalPageLayout>
);


// --- Main Legal Pages Component ---

const LegalPages = () => {
    const [activePage, setActivePage] = useState('terms'); // Default page
    const [navPage, setNavPage] = useState('home'); // Track top-nav active state

    // This effect will update the page based on the URL hash
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.replace('#', '');
            const validPages = ['terms', 'privacy', 'community', 'cookies', 'dpa', 'eula', 'rewards', 'sla', 'ai'];
            if (validPages.includes(hash)) {
                setActivePage(hash);
            } else {
                setActivePage('terms'); // Default to terms if hash is invalid or not present
            }
        };

        window.addEventListener('hashchange', handleHashChange);
        handleHashChange(); // Initial check on component mount

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    const updateActivePage = (page) => {
        setActivePage(page);
        window.location.hash = page;
    };

    const renderPage = () => {
        switch (activePage) {
            case 'terms':
                return <TermsAndConditions setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            case 'privacy':
                return <PrivacyPolicy setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            case 'community':
                return <CommunityGuidelines setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            case 'cookies':
                return <CookiePolicy setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            case 'dpa':
                return <DataProcessingAgreement setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            case 'eula':
                return <EULA setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            case 'rewards':
                return <RewardAndRaffleTerms setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            case 'sla':
                return <ServiceLevelAgreement setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            case 'ai':
                return <AiUsePolicy setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
            default:
                return <TermsAndConditions setActivePage={updateActivePage} currentPage={navPage} setCurrentPage={setNavPage} />;
        }
    };

    return (
        <div style={{ backgroundColor: 'var(--bg-color)', minHeight: '100vh' }}>
            {renderPage()}
        </div>
    );
};

export default LegalPages;
